<template>
  <div class="businessList">
    <h2>{{ nowShowBusinessRow.title }}</h2>
    <el-table :data="businessList" :stripe="false" @selection-change="HandleSelectionChange"
      @sort-change="HandleSortChange" :show-header="false" style="box-shadow: none">
      <TableOperation v-if="showOperation" :width="80" :operationList="[
        {
          is_show: (row) =>
            $store.getters.checkPermission('admin_business_action.edit') &&
            row.status != -1,
          label: '移除',
          command: 'off',
        },
      ]" @handleOperation="HandleOperation" />

      <!-- 我的意向 -->
      <el-table-column v-if="fromMe" width="50">
        {{ l("我") }}
      </el-table-column>

      <!-- 游客加密等级3 -->
      <template v-else-if="encryptLevel==3">
        <el-table-column width="120">
          <template slot-scope="scope">
              {{ scope.row.encrypt_company_name }}
          </template>
        </el-table-column>
      </template>
      
      <!-- 正常内容 -->
      <template v-else-if="encryptLevel==0">
        <!-- 用户昵称 -->
        <el-table-column width="60" show-overflow-tooltip>
          <template slot-scope="scope">
            <template v-if="scope.row.user">
              {{ scope.row.user.display_name }}
            </template>
            <template v-else>
              {{ l("匿名用户") }}
            </template>
          </template>
        </el-table-column>
        
        <!-- 公司 -->
        <el-table-column width="160" show-overflow-tooltip>
          <template slot-scope="scope">
            <span v-if="scope.row.tenant">
              {{ scope.row.tenant.name }}
            </span>
            <span v-else-if="scope.row.user" style="color:#ccc">
              {{ scope.row.user.pre_company_name }}
            </span>
          </template>
        </el-table-column>

        <!-- 用户手机号 -->
        <el-table-column width="120">
          <template slot-scope="scope">
            <template v-if="scope.row.user">
              {{ scope.row.user.mobile }}
            </template>
            <template v-else>
              -
            </template>
          </template>
        </el-table-column>
      </template>


      <!-- 游客看到的报价数字 -->
      <el-table-column v-if="encryptLevel==3">
        <template slot-scope="scope" v-if="scope.row.module == 'purchase'">
          <div style="text-align: left !important">
            报价: 
            {{ scope.row.encrypt_price }} {{ l("元") }}/{{
              scope.row.info.specification_amount[0].unit
            }}
          </div>
        </template>
      </el-table-column>

      <!-- 详情 -->
      <el-table-column v-else>
        <template slot-scope="scope">
          <div style="text-align: left !important">
            <span v-if="showOperation && scope.row.status == -1" style="color: #999">（{{ l("已失效") }}）</span>
            <template v-if="scope.row.module == 'quotation'"> {{ l("询价") }} </template>
            <template v-else-if="scope.row.module == 'purchase'">
              {{ l("报价") }}
            </template>
            <template v-else-if="scope.row.module == 'raise'">
              {{ l("参与拼单") }}
            </template>
            <span v-if="targetMode == 1" class="ViewLink" @click="goBusiness(scope.row)">{{ scope.row.info.title }}
            </span>
            ：
            <span>
              <template v-if="scope.row.module == 'purchase'">
                {{ scope.row.price }}{{ l("元") }}/{{
                  scope.row.info.specification_amount[0].unit
                }}
              </template>
              <template v-else-if="
                scope.row.module == 'quotation' || scope.row.module == 'raise'
              ">
                {{ scope.row.amount
                }}{{ scope.row.info.specification_amount[0].unit }}
              </template>
            </span>
            <span>
              {{ scope.row.extra_params }}
            </span>
          </div>
          <div v-if="scope.row.img_array" style="text-align:left">
            <el-image
              style="width:50px;height:50px;margin-right:5px;"
              v-for="item of scope.row.img_array"
              :key="item"
              :src="item"
              fit="contain"
              :preview-src-list="scope.row.img_array"
            ></el-image>
          </div>
        </template>
      </el-table-column>

      <!-- 日期 -->
      <el-table-column width="150">
        <template slot-scope="scope">
          <span style="color: #999;">
            {{scope.row.created_time.slice(0, 16)}}
          </span>
        </template>
      </el-table-column>
      
      <!-- 询价/报价来源者的专属业务员 -->
      <el-table-column width="70" v-if="encryptLevel==0">
        <template slot-scope="scope" v-if="scope.row.user">
          <template v-if="manager_caigouList.length > 0">
            {{ $utils.listFilter(manager_caigouList, scope.row.user.manager_caigou_id, "display_name") }}
          </template>
          <template v-else-if="manager_shichangList.length > 0">
            {{ $utils.listFilter(manager_shichangList, scope.row.user.manager_shichang_id, "display_name") }}
          </template>
        </template>
      </el-table-column>
    </el-table>
    <el-pagination v-if="TotalCount" style="margin-top: 30px; justify-content: center" background
      @size-change="HandleSizeChange" @current-change="HandleCurrentChange" :current-page="CurrentPage"
      :page-sizes="PageSizeList" :page-size="PageSize" layout="total, prev, pager, next, jumper"
      :total="TotalCount"></el-pagination>
  </div>
</template>

<script>
import tableMixin from "@/assets/js/tableMixin";
export default {
  name: "BusinessList",
  mixins: [tableMixin],
  props: {
    api_url: {//GetTableList请求url
      type: String,
      required: true,
    },
    targetMode: {//0不展示 1去官网
      type: Number,
      default: 0,
    },
    fromMe: {//我的意向
      type: Boolean,
      default: false,
    },
    showOperation: {//是否展示"移除"按钮(仅拼单模块)
      type: Boolean,
      default: false,
    },
    manager_caigouList: {//父元素传入的采购部业务员list
      type: Array,
      default: () => []
    },
    manager_shichangList: {//父元素传入的市场部业务员list
      type: Array,
      default: () => []
    },
    nowShowBusinessRow: {//当前business的目标,用于展示title
      type: Object,
      default: () => ({})
    },
    encryptLevel: {//信息加密等级 0后管管理员(默认) 1后管业务员 2前端业务员 3前端用户
      type: Number,
      default: 0
    }

  },
  data() {
    return {
      Sorting: "-updated_time",
      businessList: [],
    };
  },
  methods: {
    GetTableList(resetPage) {
      if (resetPage == true) this.CurrentPage = 1;
      this.axios
        .get(this.api_url, {
          params: {
            ordering: this.Sorting,
            size: this.PageSize,
            page: this.CurrentPage,
          },
        })
        .then((data) => {
          this.TotalCount = data.count;
          this.businessList = data.results.map(row=>{
            try {
              row.img_array = JSON.parse(row.img_array)
            } catch (error) {
              // console.log(error)
            }
            return row
          });
        });
    },
    goBusiness(business) {
      if (this.targetMode == 1) {
        if (business.module == "quotation") {
          this.$openRouter({
            path: `/home/quotation/${business.info.code}`,
          });
        } else if (business.module == "purchase") {
          if (business.info.quality_type == 1) {
            this.$openRouter({
              path: `/home/purchase_material/${business.info.code}`,
            });
          } else if (business.info.quality_type == 3) {
            this.$openRouter({
              path: `/home/purchase_forging/${business.info.code}`,
            });
          }
        } else if (business.module == "raise") {
          this.$openRouter({
            path: `/home/raise/${business.info.code}`,
          });
        }
      }
    },
    off(item) {
      this.$confirm(
        `${this.l("下架")}【${item.tenant.name}】?`,
        "",
        {
          type: "warning",
        }
      ).then(() => {
        this.axios
          .put(`/api/admin_business_action/${item.code}/off/`)
          .then(() => {
            this.GetTableList();
          });
      });
    },
  },
};
</script>


<style scoped lang="scss">
.businessList {
  font-size: 12px;
  padding: 0 10px;

  .businessItem {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-top: 15px;

    .date {
      flex-shrink: 0;
      width: 120px;
      color: #999;
      text-align: right;
    }
  }
}
</style>
